import * as R from 'ramda';


const getFeedbackResponseForOrganization = {
  fe2be: R.identity,
  be2fe: R.identity,
};

export default {
  getFeedbackResponseForOrganization
};
